import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../components/atoms/Icon';
import InputField from '../components/atoms/InputField';
import InputPasswordField from '../components/atoms/InputPasswordField';
import SimpleButton from '../components/atoms/SimpleButton';
import { loginUser } from '../actions';
import { connect } from 'react-redux';
import { contentChange } from '../actions/content';

import cssVars from '../assets/export.css';
var AppConfig = require('../config.json');


class LoginView extends React.Component {
	constructor(props) {
	    super(props);
      this.handleSubmit = this.handleSubmit.bind(this);
      this.handleChange = this.handleChange.bind(this);
      this.goHome = this.goHome.bind(this);
	    this.state = {auth: false, username:'', password:''};
	}

  handleChange(e) {
    var tmp = {};
      tmp[e.target.name] = e.target.value;
      this.setState(tmp);
  }

  goHome() {
    this.props.dispatch(contentChange(AppConfig.links.bundles.url));
  }


  componentWillUpdate(nextProps, nextState) {

    if(nextProps.isAuthenticated) {
      this.goHome();
      
    }
  }

	handleSubmit(e) {
		e.preventDefault();
    if(!this.props.isAuthenticating && !this.props.isAuthenticated && this.state.username!=='' && this.state.password!=='') {
      this.setState({auth:true});
      this.props.submitClick(this.state.username, this.state.password);
    }
    return false;
	}

  render () {
      return (
          <div className="contentview login">
            <div className="uppertext">
            <h6>Willkommen in unserem schoolTab Portal.</h6>
            Damit Sie im nächsten Schritt Ihre Geräte, Leistungen und Finanzierungsmöglichkeiten auswählen können, geben Sie bitte Ihre Logindaten ein. Diese bekommen Sie von Ihrer zuständigen Lehrkraft. 
            </div>
            <form className={`form${this.props.isAuthenticating===true?" doauth":""}${this.props.isAuthenticated===true?" isauth":" notauth"}${this.state.username!=='' && this.state.password!==''?" filled":""}`} onSubmit={this.handleSubmit}>
              <h2>Login</h2>
            	<InputField label="Benutzername" name="username" icon={<Icon filename="person" color="#fff" />} onChange={this.handleChange} />
            	<InputPasswordField label="Passwort" name="password" icon={<Icon filename="lock_outline" color="#fff" />} onChange={this.handleChange} />
            	<SimpleButton onClick={null} color={cssVars.brandPrimary}>{this.props.isAuthenticating===true?"Prüfe Daten":this.props.isAuthenticated===true?"OK":this.state.username!=='' && this.state.password!==''?"Anmelden »":"Logindaten eingeben"}</SimpleButton>
            </form>
            <div className="lowertext">
            Ihre Schule hat noch kein schoolTab bestellt – es besteht jedoch Interesse an der Ausstattung Ihrer Schule mit digitalen Geräten? Dann kontaktieren Sie uns gerne unter <a href="https://convergetp.de/kontakt/" target="_blank">convergetp.de/kontakt</a>
            </div>
          </div>
      );
  }

}

LoginView.propTypes = {
  color: PropTypes.string
}

LoginView.defaultProps = {
  color: "#0085AC"
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    isAuthenticating: state.auth.isAuthenticating
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch: dispatch,
    submitClick: (username, password) => {
      loginUser(username, password)(dispatch)
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoginView)



// WEBPACK FOOTER //
// ./src/views/LoginView.js